import { render, staticRenderFns } from "./InvoiceLineProductDescription.vue?vue&type=template&id=52dfb0bd&scoped=true&"
import script from "./InvoiceLineProductDescription.vue?vue&type=script&lang=ts&"
export * from "./InvoiceLineProductDescription.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceLineProductDescription.vue?vue&type=style&index=0&id=52dfb0bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dfb0bd",
  null
  
)

export default component.exports